import { render, staticRenderFns } from "./gsuite.vue?vue&type=template&id=24f6d61c"
import script from "./gsuite.vue?vue&type=script&lang=js"
export * from "./gsuite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports